import { Box, Button, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { v4 as uuid } from 'uuid';
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import { removeEquipmentList } from "../../service/equipmentListService";
import SafeWorkMethodAdd from "./safe-work-method-Add";
import { removeSafeWorkMethod } from "../../service/safeWorkMethodService";

export default function SafeWorkMethodView(props: RouteComponentProps) {

  const [selectedType, setTypes] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const client_id = props?.session?.client_id;

  const baseFilter = {
    'type': { value: '', matchMode: FilterMatchMode.CONTAINS }
  }

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedType);
    removeClient(selectedType.id);
  }

  const addButton = (row: any) => {
    console.log("addButton row == ", row)
    setTypes(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row)
    setTypes(row.value);
    editConfirm(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row)
    setTypes(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removeSafeWorkMethod(selectedType.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Safe Work Method Deleted Successfully', life: 3000 });
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

 

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }

  const unableToEdit = (row: any) => {
    toast.current.show({ severity: 'warning', summary: 'Unable To Edit DSF Safe Work Method', life: 3000 });
  }


  const contextItems = () => {
    let objArray: any[] = [];
    if (client_id === selectedType?.client_id || !client_id) {
      objArray.push({ label: 'Edit', icon: 'pi pi-fw pi-pencil', command: editConfirm });
      objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    } else {
      objArray.push({ label: 'Unable To edit', icon: 'pi pi-fw pi-times-circle', command: unableToEdit });
    }
    return objArray;
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'photo',
      header: 'Image',
      type: GenericTableColumTypes.Image,
      visible: true,
      sort: false,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'description',
      header: 'Description',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'active',
      header: 'Active',
      type: GenericTableColumTypes.Boolean,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Boolean,
        options: [{
          label: '',
          value: ''
        }]
      }
    }
  ];


  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Safe Work Method
        </Typography>


        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView reload={reload} baseFilters={baseFilter} url="safe-work-method" columns={columns} contextItems={contextItems} addButton={addButton} itemSelect={itemSelected} contextItemSelected={contextItemSelected} />

      <Dialog ref={dialog} header={selectedType?.id ? 'Update Safe Work Method' : 'Add Safe Work Method'} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)}>
        <SafeWorkMethodAdd setGlobalLoading={props.setGlobalLoader} setReload={setReload} reload={reload} id={selectedType?.id} uuid={uuid()} details={selectedType} setVisible={setVisible} toast={toast} client={client_id} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />


    </React.Fragment>
  );
}